<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="培训意见反馈" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-spin :spinning="loading">
                <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="padding:10px 20px;">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="反馈表编号">
                                <a-input ref="yjfkbbh" v-model="editData.yjfkbbh" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="反馈日期" required>
                                <a-date-picker ref="fkrq" style="width:100%" valueFormat="YYYY-MM-DD" v-model="editData.fkrq" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名单位编号">
                                <a-input ref="fkdwbh" v-model="editData.fkdwbh" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名单位名称">
                                <a-input ref="fkdwmc" v-model="editData.fkdwmc" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="班级名称" required>
                                <a-input-search ref="bjmc" readOnly @search="isShow_bjmc = true" v-model="editData.bjmc" />
                                <FGDataSelect :isShow.sync="isShow_bjmc" selectNo="JC1008" @saveselect="saveEvent_bjmc(arguments, editData)"></FGDataSelect>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="班级类别">
                                <a-input ref="bjlb" v-model="editData.bjlb" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="班级人数">
                                <a-input ref="bjrs" v-model="editData.bjrs" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名人数">
                                <a-input ref="bmrs" v-model="editData.bmrs" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名开始日期">
                                <a-input ref="ksrq" v-model="editData.ksrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名结束日期">
                                <a-input ref="jsrq" v-model="editData.jsrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="培训开始日期">
                                <a-input ref="pxksrq" v-model="editData.pxksrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="培训结束日期">
                                <a-input ref="pxjsrq" v-model="editData.pxjsrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="培训内容">
                                <a-input ref="pxnr" v-model="editData.pxnr" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="培训地点">
                                <a-input ref="pxdd" v-model="editData.pxdd" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="联系人">
                                <a-input ref="lxr" v-model="editData.lxr" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="联系电话">
                                <a-input ref="lxdh" v-model="editData.lxdh" disabled />
                            </a-form-item>
                        </a-col>

                        <a-col :span="6">
                            <a-form-item label="录入部门">
                                <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入人">
                                <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入时间">
                                <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="反馈意见" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" required>
                                <a-textarea ref="fkyj" :rows="3" v-model="editData.fkyj" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="课程安排" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="kcap" :rows="3" v-model="editData.kcap" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="教师评价" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="jspj" :rows="3" v-model="editData.jspj" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="组织管理" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="zzgl" :rows="3" v-model="editData.zzgl" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="培训建议" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="bz" :rows="3" v-model="editData.bz" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <!-- 流程跟踪组件 -->
                <OperLog ref="activitishow" :operLogProps="operLogProps"></OperLog>
            </a-spin>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "PxyjfkEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isShow_bjmc: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    activated() {
        if (!this.editDataId) {
            // 新增，设置默认值
            this.editData = {
                id: this.$FG_util.uuid(),
                isnew: true,
                yjfkbbh: "",
                fkrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                djlxid: "PXYJFKB",
                fkdwid: this.getUserInfo.companyInfo.id,
                fkdwbh: this.getUserInfo.companyInfo.dwbh,
                fkdwmc: this.getUserInfo.companyInfo.dwmc,
                bmid: this.getUserInfo.org_id,
                ryid: this.getUserInfo.personnel_id,
                yhid: this.getUserInfo.id,
                lrbmmc: this.getUserInfo.org_name,
                lrrxm: this.getUserInfo.personnel_name,
                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                djzt: "制定"
            };
            this.submitShow = false;
            this.$FG_helper.handleNewBillCode("YJFKBBH").then((val) => {
                this.editData.yjfkbbh = val;
            });
        } else {
            this.submitShow = true;
            // 修改，加载数据
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.yjfkbbh.focus();
        });
    },
    methods: {
        saveEvent_bjmc(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.bjid = val[0][0].ID;
                this.editData.bjmc = val[0][0].BJMC;
                this.editData.bjlb = val[0][0].BJLB;
                this.editData.bjrs = val[0][0].BJRS;
                this.editData.bmrs = val[0][0].BMRS;
                this.editData.ksrq = val[0][0].KSRQ;
                this.editData.jsrq = val[0][0].JSRQ;
                this.editData.pxksrq = val[0][0].PXKSRQ;
                this.editData.pxjsrq = val[0][0].PXJSRQ;
                this.editData.pxnr = val[0][0].PXNR;
                this.editData.pxdd = val[0][0].PXDD;
                this.editData.lxr = val[0][0].LXR;
                this.editData.lxdh = val[0][0].LXDH;
            }
        },
        //提交form
        onSave(btnType) {
            // 表单校验
            if (btnType === 1) {
                if (!this.editData.fkrq) {
                    this.$FG_message.error("P0001", "反馈日期").then(() => this.$refs.fkrq.focus());
                    return;
                }
                if (!this.editData.bjmc) {
                    this.$FG_message.error("P0001", "班级名称").then(() => this.$refs.bjmc.focus());
                    return;
                }
                if (!this.editData.fkyj) {
                    this.$FG_message.error("P0001", "反馈意见").then(() => this.$refs.fkyj.focus());
                    return;
                }
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/pxyjfk/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        this.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.yjfkbbh.focus();
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/jsry/pxyjfk/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.yjfkbbh.focus();
                            }
                        });
                }
            });
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/pxyjfk/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
